import { AssessmentProvider, useAssessment } from "@/context/AssessmentContext";
import { PageHeader } from "@/components/layout/PageHeader";
import { SimplifiedAssessmentDashboard } from "@/components/assessment/SimplifiedAssessmentDashboard";
import { ConversationalAssessment } from "@/components/assessment/ConversationalAssessment";
import { RouteErrorBoundary } from "@/components/error/RouteErrorBoundary";
import { startAssessmentTiming, endAssessmentTiming } from "@/utils/performance";
import { useEffect } from "react";

function AssessmentContent() {
  const {
    currentModuleId,
    exitAssessment
  } = useAssessment();

  useEffect(() => {
    if (currentModuleId) {
      startAssessmentTiming(currentModuleId);
    }
  }, [currentModuleId]);

  const handleComplete = () => {
    if (currentModuleId) {
      // Assume average of 10 questions - this could be made dynamic
      endAssessmentTiming(currentModuleId, 10);
    }
    exitAssessment();
  };

  // If no module is selected, show the simplified dashboard
  if (!currentModuleId) {
    return <SimplifiedAssessmentDashboard />;
  }

  // Use the conversational assessment flow
  return (
    <ConversationalAssessment 
      onComplete={handleComplete} 
      onExit={() => exitAssessment()} 
    />
  );
}

export default function Assessment() {
  return (
    <RouteErrorBoundary routeName="assessment" preserveProgress={true}>
      <AssessmentProvider>
        <div className="space-y-6">
          <PageHeader 
            title="Getting Started" 
          />
          <AssessmentContent />
        </div>
      </AssessmentProvider>
    </RouteErrorBoundary>
  );
}